import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik} from "formik";
import s from "./ToLuxPayTransactionTemplate.module.css";
import {Popover} from "antd";
import info from "../../../assets/img/personalAccount/information.svg";
import classnames from "classnames";
import {motion} from "framer-motion";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import CustomDropdownForAccounts from "../../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import CustomDropdown from "../../ui/CustomDropdown/CustomDropdown";
import MyBtn from "../../ui/MyBtn/MyBtn";
import MyInput from "../../ui/MyInput/MyInput";
import TransparentButton from "../../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../../assets/img/personalAccount/back.svg";
import {useNavigate} from "react-router-dom";
import CustomModal from "../../ui/CustomModal/CustomModal";
import {
    CheckAvailableAccountsByEmail,
    CheckAvaliableAccountsByPhone, ResetFieldByTransferMethod, CheckAvaliableAccountByWalletId
} from "../../ToAnLuxPayTransferForm/Helpers";
import styles from "../../../styles/styles.module.css";
import iconSuccess from "../../../assets/img/personalAccount/tick-circle.svg";
import {setIsLoading} from "../../../store/reducers/UserSlice";
import PhoneCodesInput from "../../ui/PhoneCodesInput/PhoneCodesInput";
import {setTransferDataPreview} from "../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {FormikPersist} from "../../BankTransferFormPersonal/FormHelpers/FormikPersist";
import * as yup from "yup";
import {clearFormByChangeType} from "../../../helpers/clearFormHelper";

type PropsType = {
    id?: string | number;
    templateName: string,
    isButtonDisable: boolean,
    setPurpose: Dispatch<SetStateAction<string>>
    withdrawalStatus: string
    purpose?: string
}

const CurrencyHelper = (props: any) => {

    useEffect(() => {
        props.accountsList.map((account: any) => {

            if (account.accountMainIban === props.payerAccount) {
                props.setCurrency(account.currency)
            }
        })
    }, [props.accountsList])

    return null
}


const ToLuxpayTransactionTemplate = (props: PropsType) => {
    // сортировка только по мерчан банку внутри транзакций. Комментарий от бек.
    const accountsList = useAppSelector(state => state.userReducer.accountsList.accounts).filter((account: any) => account.accountMainIban !== "ALL")
    const navigate = useNavigate()
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const dispatch = useAppDispatch()
    const [isShowSuccessModal, setIsShowSuccessModal] = useState(false)
    const [currency, setCurrency] = useState('')
    const [isRequestDenied, setIsRequestDenied] = useState<boolean | null>(false)
    const [isAvailableAccountExists, setIsAvailableAccountExists] = useState<boolean | null>(true)
    const [accountNumber, setAccountNumber] = useState('')
    const [localyDisabled, setLocalyDisabled] = useState(true)
    const [isListOfAccounts, setIsListOfAccounts] = useState<any>()
    const [isHisOwnRecipientData, setIsHisOwnRecipientData] = useState<boolean | null>(false)
    const [errorText, setErrorText] = useState('')
    const [isInputErrorShow, setIsInputErrorShow] = useState(false)

    const validationSchemaForTemplate = yup.object({
        accNumberFrom: yup.string().test({
            message: 'Required field',
            test: function (value) {
                // вместо account number => wallet id

                return true
            },
        }),
        accNumberTo: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                // вместо account number => wallet id
                if (transferMethod === 'Wallet Id' || transferMethod === 'account') return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
        accountType: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (isListOfAccounts?.length === 2 && (transferMethod === 'phone number' || transferMethod === 'email')) {
                    return value !== undefined && value !== null && value !== '';
                }
                return true;
            },
        }),
        transferMethod: yup.string().required('Required field'),
        phoneNumber: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (transferMethod === 'phone number') return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
        email: yup.string().test({
            message: 'Required field',
            test: function (value) {
                const {transferMethod} = this.parent;
                if (transferMethod === 'email') return value !== undefined && value !== null && value !== '';
                return true
            },
        }),
        purpose: yup.string().max(100, 'max 100 symbols')

    })

    useEffect(() => {
        if (!accountNumber) {
            return
        }
        sessionStorage.setItem("accountNumber", accountNumber)
    }, [accountNumber])

    useEffect(() => {
        const accNumber = sessionStorage.getItem("accountNumber")
        if (accNumber) {
            setAccountNumber(accNumber)
        }
    }, [])

    const transferMethods = [
        'Wallet Id',
        'email',
        'phone number'
    ]

    const accountType = [
        'personal',
        'business',
    ]

    const closeAndRedirect = () => {
        setIsShowSuccessModal(false)
        navigate(-1)
    }

    const myInitValues = {
        accNumberFrom: '',
        accNumberTo: '',
        email: '',
        phoneNumber: '',
        emailLanguage: 'EN',
        reference: '',
        amount: '',
        transferMethod: 'Wallet Id',
        type: 'internal',
        invoice: '',
        purpose: '',
        hiddenAccountNumber: '',
        transferCurrency: '',
        accountType: '',
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
            className={s.form_wrapper}
        >
            <Formik
                initialValues={myInitValues}
                validationSchema={validationSchemaForTemplate}
                validateOnMount={false}
                validateOnChange={true}
                validateOnBlur={true}
                onSubmit={async (values) => {

                    if (props.templateName === '') {
                        return
                    }

                    setLocalyDisabled(true)
                    // dispatch(setDisabled(true))
                    //@ts-ignore
                    const selectedAccount = isListOfAccounts?.find((account: any) => account.clientType === values.accountType.toLocaleLowerCase());
                    if (selectedAccount) {
                        values.hiddenAccountNumber = selectedAccount.number;
                    }

                    let tempTransferMethod: string | null = ''

                    if (values.transferMethod === 'phone number' || values.transferMethod === 'phone') {
                        tempTransferMethod = 'phone'
                    }

                    if (values.transferMethod === 'email') {
                        tempTransferMethod = 'email'
                    }

                    if (values.transferMethod === 'Wallet Id') {
                        tempTransferMethod = 'account'
                    }

                    const tempData = {
                        ...values,
                        templateName: props.templateName,
                        accountNumber: accountNumber,
                        transferMethod: tempTransferMethod
                    }

                    const requestData = {
                        ...tempData,
                        accountId: accountId
                    }

                    dispatch(setTransferDataPreview({
                        ...requestData,
                        isTemplateCreation: true,
                        templateType: props.purpose,
                        templateName: props.templateName
                    }))

                    dispatch(setIsLoading(false))
                    navigate('/personal-account/templates/transfer-data-preview')

                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue,
                      setValues
                  }) => (
                    <form onSubmit={handleSubmit}>

                        <CustomModal isModalOpen={isShowSuccessModal} type="confirm">
                            <div className={classnames(styles.modal_content, s.modal_content_center)}>
                                <img src={iconSuccess} alt="" className={styles.popup_icon}/>
                                <div className={styles.popup_title}>
                                    Success!
                                </div>
                                <div className={styles.popup_subtitle}>
                                    Your template has been added successfully.
                                </div>
                                <div className={styles.popup_button_block}>
                                    <MyBtn title={"Ok"}
                                           medium
                                           isPersonalAccountBtn
                                           onClick={() => closeAndRedirect()}
                                    />
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={!isAvailableAccountExists}
                                     setIsModalOpen={setIsAvailableAccountExists}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> The transfer cannot be made to the
                                    specified&nbsp;
                                    {values.transferMethod?.toLowerCase()} due to the lack of an account with the
                                    recipient.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsAvailableAccountExists(true)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isRequestDenied}
                                     setIsModalOpen={setIsRequestDenied}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> Your request was rejected.
                                    <br/>Please try again.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        navigate('/personal-account/templates')
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isHisOwnRecipientData}
                                     setIsModalOpen={setIsHisOwnRecipientData}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> {errorText}
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsHisOwnRecipientData(null)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <div className={s.row}>
                            <div className={s.input_block}>
                                <div className={s.input_label}>
                                    <span><span className={s.red}>*</span> Payer account</span>
                                    <Popover content={"Please select the account you wish to make a transfer from."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    placeholder={"Please select the account"}
                                    id="accNumberFrom"
                                    name="accNumberFrom"
                                    isError={errors.accNumberFrom}
                                    touched={touched.accNumberFrom}
                                    setAccountNumber={setAccountNumber}
                                    disabled={props.id !== 'create'}
                                    setCurrency={(selectedCurrency) => {
                                        setCurrency(selectedCurrency);
                                    }}
                                />
                                {errors.accNumberFrom &&
                                    <div className={s.error_message}>{errors.accNumberFrom}</div>}
                            </div>

                            <div className={s.input_block}>
                                <div className={s.input_label}>
                                    <span><span className={s.red}>*</span> Transfer Method</span>
                                    <Popover content={"Choose one of the recipient’s identifiers: their LuxPay" +
                                        " account, email address or phone number."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdown
                                    items={transferMethods}
                                    id="transferMethod"
                                    name="transferMethod"
                                    isError={errors.transferMethod}
                                    touched={touched.transferMethod}
                                    disable={props.id !== 'create'}
                                    setItem={(value: string) => {
                                        clearFormByChangeType(
                                            values,
                                            setValues,
                                            [
                                                "purpose",
                                                "transferCurrency",
                                                "type",
                                                "amount",
                                                "emailLanguage",
                                                "accNumberFrom",
                                            ]
                                        )
                                        setIsListOfAccounts(null)
                                        setFieldValue('transferMethod', value);
                                    }}
                                />
                            </div>
                        </div>

                        <div className={s.block}>
                            <div className={s.title}>
                                Outgoing Payment Details
                            </div>

                            <div className={s.row}>

                                <div className={s.input_block}>
                                    {values.transferMethod === 'Wallet Id'
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> Wallet ID</span>
                                            </div>
                                            <MyInput id={"accNumberTo"}
                                                     name={"accNumberTo"}
                                                     touched={touched.accNumberTo}
                                                     value={values.accNumberTo}
                                                     onChange={handleChange}
                                                     isError={isInputErrorShow || (touched.accNumberTo && !!errors.accNumberTo)}
                                                     placeholder={"Enter wallet id"}
                                                     disabled={false}
                                            />
                                            {errors.accNumberTo && touched.accNumberTo &&
                                                <div className={s.error_message}>{errors.accNumberTo}</div>}
                                            {!errors.accNumberTo && isInputErrorShow &&
                                                <div className={s.error_message}>invalid wallet Id</div>}
                                        </div>
                                    }

                                    {values.transferMethod === 'email'
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                *Email
                                            </div>
                                            <MyInput id={"email"}
                                                     name={"email"}
                                                     touched={touched.email}
                                                     value={values.email}
                                                     onChange={handleChange}
                                                     isError={isInputErrorShow || (touched.email && !!errors.email)}
                                                     disabled={false}
                                            />
                                            {errors.email && touched.email &&
                                                <div className={s.error_message}>{errors.email}</div>}
                                            {!errors.email && isInputErrorShow &&
                                                <div className={s.error_message}>invalid email</div>}
                                        </div>
                                    }

                                    {(values.transferMethod === 'phone number' || values.transferMethod === 'phone')
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> phone number</span>
                                                <Popover
                                                    content={"Phone number in international format."}
                                                    color={'#EEEFEF'}
                                                    overlayInnerStyle={{
                                                        fontFamily: 'Manrope',
                                                        width: '280px',
                                                        padding: '13px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#E7F0EC'
                                                    }}
                                                >
                                                    <img src={info} alt=""/>
                                                </Popover>
                                            </div>
                                            <PhoneCodesInput
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                error={isInputErrorShow || (touched.phoneNumber && !!errors.phoneNumber)}
                                                touched={touched.phoneNumber}
                                                disabled={false}
                                                tiny
                                            />
                                            {!errors.phoneNumber && isInputErrorShow &&
                                                <div className={s.error_message}>invalid phone number</div>}
                                        </div>
                                    }

                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        Purpose
                                    </div>
                                    <MyInput id={"purpose"}
                                             name={"purpose"}
                                             touched={touched.purpose}
                                             value={values.purpose}
                                             onChange={handleChange}
                                             isError={errors.purpose}
                                             placeholder={"Enter your purpose of payment"}
                                             disabled={false}
                                    />
                                    {errors.purpose && <div className={s.error_message}>{errors.purpose}</div>}
                                </div>

                            </div>
                            <div className={s.row}>
                                <div className={s.mobile_row}>

                                    <div className={s.currency_dropdown}>
                                        <div className={s.input_label}>
                                        </div>
                                        <MyInput
                                            id="transferCurrency"
                                            name="transferCurrency"
                                            value={currency}
                                            disabled={true}
                                        />
                                    </div>

                                    <div className={classnames(s.input_block, s.short)}>
                                        {
                                            //@ts-ignore
                                            isListOfAccounts?.length > 1 &&
                                            <div className={s.input_block}>
                                                <div className={s.input_label}>
                                                        <span><span
                                                            className={s.red}>*</span> RECIPIENT ACCOUNT TYPE</span>
                                                </div>
                                                <CustomDropdown
                                                    items={accountType}
                                                    id="accountType"
                                                    name="accountType"
                                                    isError={errors.accountType}
                                                    touched={touched.accountType}
                                                />
                                                {errors.accountType && touched.accountType &&
                                                    <div className={s.error_message}>{errors.accountType}</div>}
                                            </div>
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className={s.continue_block}>
                            <div className={s.required}>
                                <div>
                                    <span><span className={s.red}>*</span> required fields.</span>
                                </div>
                            </div>
                        </div>

                        <div className={s.buttonsWrapper}>
                            <div className={s.button_block}>
                                <TransparentButton title={'Back'}
                                                   isPersonalAccountBtn
                                                   large
                                                   icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                                   onClick={() => {
                                                       navigate(-1);
                                                   }}/>
                            </div>

                            <MyBtn title={'Save'}
                                   large
                                   style={{width: 180}}
                                   type="submit"
                                   isPersonalAccountBtn
                                   localDisable={props.isButtonDisable || localyDisabled}
                                   onClick={() => {
                                       handleSubmit();
                                   }}
                            />
                        </div>

                        <FormikPersist name="template-internal-form"/>

                        <CurrencyHelper
                            accountsList={accountsList}
                            payerAccount={values.accNumberFrom}
                            setCurrency={setCurrency}
                            setAccountNumber={setAccountNumber}
                            errors={errors}
                            values={values}
                        />

                        <CheckAvailableAccountsByEmail
                            name={"accNumberTo"}
                            email={values.email}
                            token={token}
                            setErrorText={setErrorText}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsListOfAccounts={setIsListOfAccounts}
                            setIsButtonDisabled={setLocalyDisabled}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            transferMethod={values.transferMethod}
                            setIsInputErrorShow={setIsInputErrorShow}
                            accNumberTo={"accNumberTo"}
                        />

                        <CheckAvaliableAccountsByPhone
                            name={"accNumberTo"}
                            phone={values.phoneNumber}
                            token={token}
                            setErrorText={setErrorText}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsListOfAccounts={setIsListOfAccounts}
                            setIsButtonDisabled={setLocalyDisabled}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            transferMethod={values.transferMethod}
                            setIsInputErrorShow={setIsInputErrorShow}
                            accNumberTo={"accNumberTo"}
                        />

                        <CheckAvaliableAccountByWalletId
                            name={"hiddenAccountNumber"}
                            account={values.accNumberTo}
                            token={token}
                            setErrorText={setErrorText}
                            currency={currency}
                            setIsAvailableAccountExists={setIsAvailableAccountExists}
                            setIsButtonDisabled={setLocalyDisabled}
                            setIsHisOwnRecipientData={setIsHisOwnRecipientData}
                            transferMethod={values.transferMethod}
                            setIsInputErrorShow={setIsInputErrorShow}
                        />

                        <ResetFieldByTransferMethod
                            name={"email"}
                            handleReset={() => {

                            }}
                        />
                        <ResetFieldByTransferMethod
                            name={"phoneNumber"}
                            handleReset={() => {

                            }}
                        />
                        <ResetFieldByTransferMethod
                            name={"accNumberTo"}
                            handleReset={() => {

                            }}
                        />

                    </form>
                )}
            </Formik>
        </motion.div>
    );
};

export default ToLuxpayTransactionTemplate;
